import useTenantContext from './useTenantContext';

export function useTenant() {
    return useTenantContext().tenant?.code;
}

export default useTenant;
